import PropTypes                    from 'prop-types';
import React                        from 'react';
import Flux                         from '../../flux/Flux';
import FeedPostList                 from './FeedPostList';
const FeedFilter = React.lazy(() => import('./FeedFilter'));
const FeedSidebar = React.lazy(() => import('./FeedSidebar'));
import {getCommonTranslation}       from '../../utils/TranslationHelper';
import {setUrlParameter} from './FeedHelper';
import "../../../../src/VX/Asset/Less/VX/View/Feed.less";
import withSuspense from '../HigherOrderComponents/Utility/withSuspense';


const TYPE_GROUPS = [
	{
		filter: Flux.Constants.Feed.Filter.CLIP_POSTS,
		text:   getCommonTranslation('videos')
	},
	{
		filter: Flux.Constants.Feed.Filter.PHOTOS_POSTS,
		text:   getCommonTranslation('photos')
	},
	{
		filter: Flux.Constants.Feed.Filter.TEXT_POSTS,
		text:   getCommonTranslation('text'),
	}
];

const FILTER = [
	...TYPE_GROUPS,
	{
		filter: Flux.Constants.Feed.Filter.BOUGHT,
		text:   getCommonTranslation('bought'),
	},
	{
		filter: Flux.Constants.Feed.Filter.LIKED,
		text:   getCommonTranslation('liked'),
	},
	{
		filter: Flux.Constants.Feed.Filter.COMMENTED,
		text:   getCommonTranslation('commented'),
	},
];

const SCROLL_TOLERANCE = 100;
let _lastContentHeight = 0;
let _lastScroll        = 0;
let _showStickyFilter  = false;

class Feed extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			selectedFilter:       this.getCurrentFilter(),
			isMobile:             this.props.isMobile || (Flux.Browser.getViewPort() === Flux.Constants.Grid2.BREAKPOINTS.XS),
			totalPostCount:       0,
			onlyFavorites:        this.getOnlyFavorites(),
		};

		this.onFilterChange = this.onFilterChange.bind(this);
		this.onResize       = this.onResize.bind(this);
		this.onScroll       = this.onScroll.bind(this);
		this.setTotalCount  = this.setTotalCount.bind(this);

		this.sidebarRef   = null;
		this.containerRef = null;
		this.postListRef  = null;
		this.wrapperRef   = null;
		this.filterRef    = null;
	}

	componentDidMount() {
		Flux.Browser.addWindowScrollListener(this.onScroll);
		Flux.Browser.addWindowResizeListener(this.onResize);
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onResize);
		Flux.Browser.removeWindowScrollListener(this.onScroll);
		this.signupModalBoxOpened = true;
	}

	setContainerRef(ref) {
		if (ref) {
			this.containerRef = ref;
			const resize      = new ResizeObserver(() => {
				this.onScroll();
			});
			resize.observe(ref);
		}
	}

	removeStickyFilter() {
		if (_showStickyFilter) {
			this.filterRef.stickyRef.classList.remove('feed__filter-wrapper--sticky-fixed');
			this.filterRef.stickyRef.style.width = null;
			this.filterRef.stickyRef.style.top   = null;
			this.filterRef.stickyRef.style.left  = null;
			_showStickyFilter                    = false;
		}
	}

	onScroll() {
		const extraSpace      = -300; // when to preload
		const containerTop    = this.containerRef.getBoundingClientRect() && this.containerRef.getBoundingClientRect().top;
		const containerHeight = this.containerRef.getBoundingClientRect() && this.containerRef.getBoundingClientRect().height;
		const containerBottom = containerTop + containerHeight;

		if ((containerBottom + extraSpace) < (window.innerHeight) && this.postListRef) {
			this.postListRef.loadMore();
		}

		const top    = typeof this.props.getTopDistance === 'function' ? this.props.getTopDistance() : 0;
		const filter = this.filterRef;
		if (!this.state.isMobile) {
			const containerWidth = this.containerRef.getBoundingClientRect() && this.containerRef.getBoundingClientRect().width;
			if (!this.wrapperRef) {
				return;
			}
			const wrapperRefWidth = this.wrapperRef.getBoundingClientRect() && this.wrapperRef.getBoundingClientRect().width;
			const sidebar         = this.sidebarRef;
			const sidebarWrapper  = sidebar?.sidebarWrapperRef;
			const sidebarTop      = sidebarWrapper?.getBoundingClientRect() && sidebarWrapper?.getBoundingClientRect().top;
			const sidebarHeight   = sidebarWrapper?.getBoundingClientRect() && sidebarWrapper?.getBoundingClientRect().height;
			const sidebarBottom   = sidebarTop + sidebarHeight;

			// prevent jump sidebar because of return if containerHeight changed by load more
			if (_lastContentHeight < containerHeight) {
				_lastContentHeight = containerHeight;
				return;
			}
			if ((top > (containerTop))) {
				/* Fixed Sidebar handling */
                if (sidebarWrapper) {
                    sidebarWrapper.classList.add('feed__sidebar-wrapper--fixed');
                    sidebarWrapper.style.width = (containerWidth - wrapperRefWidth - (window.innerHeight < 850 ? 10 : 20)) + 'px';
                    if ((sidebarBottom) > (containerBottom)) {
                        sidebarWrapper.style.top           = (this.containerRef.getBoundingClientRect().top + containerHeight) - sidebarHeight + 'px';
                        sidebar.sidebarRef.style.maxHeight = window.innerHeight - top - 20 + 'px';
                    } else if (containerBottom < sidebarHeight + top) {
                        sidebarWrapper.style.top           = containerBottom - sidebarHeight + "px";
                        sidebar.sidebarRef.style.maxHeight = window.innerHeight - top - 20 + 'px';
                    } else {
                        sidebarWrapper.style.top           = top + "px";
                        sidebar.sidebarRef.style.maxHeight = window.innerHeight - top - 20 + 'px';
                    }
                }

				const currentScroll = window.scrollY;
				/* Sticky Filterbar handling */
				if (!Flux.Feed.getSelectedPostId(this.props.feedType) && this.filterRef && (currentScroll - SCROLL_TOLERANCE > _lastScroll || currentScroll + SCROLL_TOLERANCE < _lastScroll)) {
					//if scrolling further, remove additional filter part
					if ((filter.state.showFilter || filter.state.showStickyFilter) && !filter.itemsHasChanged) {
						filter.toggleFilter();
					}

					if (_lastScroll < currentScroll) {
						//scroll down
						this.removeStickyFilter();
					} else {
						//scroll up
						if (containerTop + 10 > top) {
							this.removeStickyFilter();
						} else if (!_showStickyFilter) {
							this.setStickyFilterPosition(top);
						}
					}
					_lastScroll = currentScroll;
				}
			} else {
                if (sidebarWrapper) {
                    sidebarWrapper.style.top   = null;
                    sidebarWrapper.style.width = null;
                    sidebarWrapper.classList.remove('feed__sidebar-wrapper--fixed');
                }
				this.removeStickyFilter();
			}
		} else if (!Flux.Feed.getSelectedPostId(this.props.feedType) && this.filterRef) {
			if (this.postListRef.postListRef.getBoundingClientRect().top < top + filter.filterRef.getBoundingClientRect().height - 20) {
				const currentScroll = window.scrollY;
				if (currentScroll - SCROLL_TOLERANCE > _lastScroll || currentScroll + SCROLL_TOLERANCE < _lastScroll) {
					if ((filter.state.showFilter || filter.state.showStickyFilter) && !filter.itemsHasChanged) {
						filter.toggleFilter();
					}
					if (_lastScroll < currentScroll) {
						this.removeStickyFilter();
					} else {
						this.setStickyFilterPosition(top);
					}
					_lastScroll = currentScroll;
				}
			} else {
				this.removeStickyFilter();
			}
		}
	}

	setStickyFilterPosition(top = null) {
		top = top || (typeof this.props.getTopDistance === 'function' ? this.props.getTopDistance() : 0);
		this.filterRef.stickyRef.classList.add("feed__filter-wrapper--sticky-fixed");
		this.filterRef.stickyRef.style.top = top + "px";
		if (this.props.isMobile) {
			this.filterRef.stickyRef.style.width = '100vw';
		} else {
			this.filterRef.stickyRef.style.width = this.postListRef.postListRef.getBoundingClientRect().width + "px";
			this.filterRef.stickyRef.style.left  = this.postListRef.postListRef.getBoundingClientRect().left + "px";
		}
		_showStickyFilter = true;
	}

	onFilterChange({selectedFilters, onlyFavorites = this.state.onlyFavorites}) {
		const filter = [...this.state.selectedFilter];
		if (selectedFilters && selectedFilters.length > 0) {
			selectedFilters.map(item => {
				if (filter.includes(item)) {
					filter.splice(filter.indexOf(item), 1);
				} else {
					filter.push(item);
				}
			});
		}
		setUrlParameter({filter, onlyFavorites});
		this.setState({selectedFilter: filter, onlyFavorites}, () => {
			const top = 0;
			window.scrollTo({
				top: this.containerRef.getBoundingClientRect().top + window.scrollY - top - this.filterRef.filterRef.getBoundingClientRect().height - 50,
			});
		});
	}

	getOnlyFavorites() {
		const queryString = window.location.search;
		const urlParams   = new URLSearchParams(queryString);
		return urlParams.get('favorites') ? true : false;
	}

	getCurrentFilter() {
		const queryString = window.location.search;
		const urlParams   = new URLSearchParams(queryString);
		const filter      = urlParams.get('filter');
		return filter ? filter.split(',') : [];
	}

	onResize() {
		this.setState({
			isMobile: this.props.isMobile || (Flux.Browser.getViewPort() === Flux.Constants.Grid2.BREAKPOINTS.XS)
		}, () => {
			this.filterRef && _showStickyFilter && this.setStickyFilterPosition();
		});
	}

	setTotalCount(totalPostCount) {
		this.setState({totalPostCount});
	}

	getTypeGroups() {
		const typeGroups = TYPE_GROUPS.map(item => item.filter);
		const filter     = this.state.selectedFilter.filter(item => typeGroups.includes(item));
		return filter.length < 1 ? null : filter;
	}

	getOnlyBought() {
		return this.state.selectedFilter.find(item => item === Flux.Constants.Feed.Filter.BOUGHT);
	}

	getLiked () {
		return this.state.selectedFilter.find(item => item === Flux.Constants.Feed.Filter.LIKED);
	}

	getCommented () {
		return this.state.selectedFilter.find(item => item === Flux.Constants.Feed.Filter.COMMENTED);
	}

	render() {
		const showFilter = Flux.Guest.isLoggedIn();
		const filter = {
			bought:    this.getOnlyBought(),
			favorites: this.state.onlyFavorites,
			liked:     this.getLiked(),
			commented: this.getCommented()
		};

		return (
			withSuspense(<div className={'feed__overview' + (showFilter ? " feed__overview--filter" : " ")} ref={ref => this.setContainerRef(ref)}>
					{!this.state.isMobile && <FeedSidebar totalPostCount={this.state.totalPostCount}
					                                      ref={ref => this.sidebarRef = ref}
					>{this.props.sidebarContent}</FeedSidebar>}
					{showFilter && <FeedFilter feedType={this.props.feedType}
					                           isMobile={this.state.isMobile}
					                           filter={FILTER}
					                           onlyFavorites={filter.favorites}
					                           selectedFilter={this.state.selectedFilter}
					                           onFilterChange={this.onFilterChange}
					                           showCount={this.props.showCount}
					                           ref={ref => this.filterRef = ref}
					                           favorites={this.props.favorites}
											   modelId={this.props.actorId}

					/>}
					<div className="feed__wrapper" ref={ref => this.wrapperRef = ref}>
						<FeedPostList typeGroups={this.getTypeGroups()}
						              onlyFavorites={filter.favorites}
						              isMobile={this.state.isMobile}
						              actorId={this.props.actorId}
						              ref={ref => this.postListRef = ref}
						              hasAvs={Flux.Guest.hasAvs()}
						              feedType={this.props.feedType}
									  filter={filter}
									  setTotalCount={this.setTotalCount}
						/>
					</div>
				</div>)
		);
	}
}

Feed.propTypes = {
	sidebarContent:  PropTypes.func.isRequired,
	navigationItems: PropTypes.array,
	feedType:        PropTypes.oneOf([
		Flux.Constants.Feed.FeedType.PROFILE,
		Flux.Constants.Feed.FeedType.MIXED,
	]).isRequired,
	getTopDistance:  PropTypes.func,
	actorId:         PropTypes.number,
	isMobile:        PropTypes.bool,
	observeSticky:   PropTypes.bool,
	showCount:       PropTypes.bool,
	favorites:       PropTypes.array,
};

Feed.defaultProps = {
	actorId:        null,
	isMobile:       true,
	observeSticky:  false,
	showCount:      true,
	getTopDistance: null,
	favorites:      [],
};


export default Feed;
